import { Box, useTheme } from '@mui/material'
import { C100Timeframe, C100_TIMEFRAMES } from '../../_types/carnivore100.type'
import { c100Tokens } from './c100-tokens'

const MONO = "'IBM Plex Mono', monospace"

export default function TimeframeSelector({
  value,
  onChange
}: {
  value: C100Timeframe
  onChange: (tf: C100Timeframe) => void
}) {
  const theme = useTheme()
  const t = c100Tokens(theme)

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        bgcolor: t.elevated,
        border: `1px solid ${t.hairline}`,
        borderRadius: 999,
        p: 0.25,
        mb: 2
      }}
    >
      {C100_TIMEFRAMES.map(tf => {
        const active = value === tf
        return (
          <Box
            key={tf}
            component="button"
            onClick={() => onChange(tf)}
            sx={{
              fontFamily: MONO,
              fontSize: 12,
              fontWeight: active ? 600 : 400,
              letterSpacing: '0.06em',
              color: active ? t.accent : t.muted,
              bgcolor: active ? t.faintAccentBg : 'transparent',
              border: 'none',
              borderRadius: 999,
              cursor: 'pointer',
              px: 1.5,
              py: 0.5,
              transition: 'all .18s',
              minWidth: 40,
              textAlign: 'center',
              '&:hover': {
                color: active ? t.accent : t.text
              }
            }}
          >
            {tf}
          </Box>
        )
      })}
    </Box>
  )
}
